/**
 * Filtro de filas por botón para las tablas comparativas (<tabla-discos>): cada botón [data-filtro]
 * muestra las filas cuyo data-materiales contiene ese valor; un filtro vacío muestra todas.
 */
if (!customElements.get('tabla-discos')) {
  customElements.define(
    'tabla-discos',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const boton = event.target.closest('[data-filtro]');
          if (!boton) return;
          const filtro = boton.dataset.filtro;
          this.querySelectorAll('[data-filtro]').forEach((b) => b.classList.toggle('is-active', b === boton));
          this.querySelectorAll('tbody tr').forEach((fila) => {
            const valores = (fila.dataset.materiales || '').split(' ');
            fila.hidden = filtro !== '' && !valores.includes(filtro);
          });
        });
      }
    }
  );
}
